// @ts-nocheck
import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Tiny ghost icon button used in section headers.
 * Non-destructive: triggers the parent section's GET endpoint, leaves
 * analyst review state and seeded adjustments untouched.
 */
const RefreshSection = ({ onRefresh, busy = false, label = 'Refresh this section' }) => (
  <button
    className="qoe-wb-refresh-section"
    onClick={onRefresh}
    disabled={busy}
    title={label}
    aria-label={label}
  >
    <RefreshCw size={12} className={busy ? 'spinning' : ''} />
  </button>
);

export default RefreshSection;
